import { Flex, Text, mainTheme } from 'dash-ui';

import { Amenity } from 'gql/generated.graphql';

import {
  AmenityImage,
  AmenityItemWrapper,
  AmenityNameWrapper,
} from 'pages/amenities/AmenitiesPage/components/AmenitiesList/components/AmenityItem/AmenityItem.styles';

interface IProps {
  amenity: Amenity;
}

function AmenityItem({
  amenity,
}: IProps) {
  return (
    <AmenityItemWrapper
      w={230}
      h="fit-content"
      pb={2}
      pt={8}
      justifyContent="center"
      alignItems="center"
    >
      <Flex flexDirection="column" alignItems="center">
        <AmenityImage
          fit="scale-down"
          size={64}
          src={amenity.imageUrl || ''}
          alt={amenity.name}
        />
        <AmenityNameWrapper w={174}>
          <Text color={mainTheme.colors.n80}>{amenity.name}</Text>
        </AmenityNameWrapper>
      </Flex>
    </AmenityItemWrapper>
  );
}

export default AmenityItem;
